import { Outlet } from 'react-router-dom'

import { Auth, Report, User } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'
import Signature from 'Components/FormGroup/Signature'

const user = [
    {
        path: 'user',
        element: <Auth guard="user" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'user',
        element: <Report guard="user" />,
        children: [{ path: 'transformer-tests/:id/report', element: <Lazy view="User/TransformerTests/Report" /> }],
    },
    {
        path: 'user',
        element: <User guard="user" />,
        children: [
            { path: '', element: <Lazy view="User/Dashboard" /> },
            { path: 'profile', element: <Lazy view="User/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },
            { path: 'signature', element: <Signature /> },

            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Roles/List" /> },
                    { path: 'create', element: <Lazy view="User/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Users/List" /> },
                    { path: 'create', element: <Lazy view="User/Users/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Users/Create" title="Edit" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Customers/List" /> },
                    { path: 'create', element: <Lazy view="User/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'inspectors',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Inspectors/List" /> },
                    { path: 'create', element: <Lazy view="User/Inspectors/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Inspectors/Create" title="Edit" /> },
                ],
            },
            {
                path: 'projects',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Projects/List" /> },
                    { path: 'create', element: <Lazy view="User/Projects/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Projects/Create" title="Edit" /> },
                ],
            },
            {
                path: 'transformers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Transformers/List" /> },
                    { path: 'create', element: <Lazy view="User/Transformers/Create" title="Add new" /> },
                    { path: ':id', element: <Lazy view="User/Transformers/View" title="View" /> },
                    { path: ':id/edit', element: <Lazy view="User/Transformers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'test-types',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/TestTypes/List" /> },
                    { path: 'create', element: <Lazy view="User/TestTypes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/TestTypes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'transformer-tests',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/TransformerTests/List" /> },
                    { path: 'create', element: <Lazy view="User/TransformerTests/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/TransformerTests/Create" title="Edit" /> },
                    { path: ':id/tests', element: <Lazy view="User/Tests/List" /> },
                    { path: ':id/tests/:test_id', element: <Lazy view="User/Tests/View" title="View" /> },
                    { path: ':id/tests/:test_id/edit', element: <Lazy view="User/Tests/Create" title="Apply" /> },
                    { path: ':id/reports', element: <Lazy view="User/TransformerTests/Reports" /> },
                ],
            },
            {
                path: 'feedbacks',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="User/Feedbacks/List" /> },
                    { path: 'create', element: <Lazy view="User/Feedbacks/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="User/Feedbacks/Create" title="Edit" /> },
                ],
            },
            {
                path: 'reports',
                element: <Outlet />,
                children: [
                    {
                        path: 'customer-satisfaction',
                        element: <Lazy view="User/Reports/CustomerSatisfaction" title="Customer Satisfaction" />,
                    },
                    {
                        path: 'monthly-customer-satisfaction',
                        element: <Lazy view="User/Reports/MonthlyCustomerSatisfaction" title="Monthly Satisfaction" />,
                    },
                    {
                        path: 'customer-comments',
                        element: <Lazy view="User/Reports/CustomerComments" title="Customer Comments" />,
                    },
                ],
            },
        ],
    },
]

export default user
